import React from 'react';
import { Link } from 'react-router-dom'
import TextField from 'material-ui/TextField';
import {Row,Col} from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash';
import * as actions from '../../../Actions/signup';
import { connect } from 'react-redux';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import CircularProgress from 'material-ui/CircularProgress';

class IntergrationInformation extends React.Component{
  constructor(props){
        super(props);
        this.state = {
            simproApi: false,
            information: 'deactivate-information',
            value: 0,
            simpro_domain_value: 'simprosuite.com',
            company_name:'',
            company_name_req:'',
            simpro_pass_req: '',
            simpro_name_req:'',
            selectCompanyReq: '',
            buttonDisable: false,
            buttonDisableInteg: false,
            simproUsername:'',
            simproPassword:'',
            disableVerifyButton: false,
            apiVerified: false,
            verifyingApi:false,
            companyIderror: null
        };
        this.submitsimproApiInteg= this.submitsimproApiInteg.bind(this);
        this.InformationToggle = this.InformationToggle.bind(this);
        this.authorizeApi = this.authorizeApi.bind(this);
        this.changeCompanyName = this.changeCompanyName.bind(this);
        this.simPROUser = this.simPROUser.bind(this);
        this.simPROpassword = this.simPROpassword.bind(this);
        this.verifyApiUserPass = this.verifyApiUserPass.bind(this);
  }
  handleChange1 = (event, index, value) => this.setState({simpro_domain_value:value});
  handleChange2 = (event, index, value) => this.setState({value:value});
  InformationToggle(){
    let value =  (this.state.information === 'deactivate-information') ? 'active-information' : 'deactivate-information' 
    this.setState({ information : value });
  }
  componentDidMount(){
    var companyId=this.props.signUp.signupUser ? this.props.signUp.signupUser.company._id : '';
    if(companyId===''){
         companyId= window.localStorage.getItem('temp_company_id');
      }
    this.props.checkCompaniesFromApi(companyId);
    
  }
  componentWillReceiveProps(nextProps){
      let checkButtonstatus=nextProps.signUp.disableaAuthorizeButton;
      let buttonDisableInteg=nextProps.signUp.buttonDisableInteg;
      let disableVerifyButton=nextProps.signUp.disableVerifyButton;
      let apiVerified=nextProps.signUp.apiVerified;
      let verifyingApi=nextProps.signUp.verifyingApi;

      let incorrectUrl=nextProps.signUp.incorrectUrl?'Your authorisation was unsuccessful. Please check your simPRO details and try again':'';
      this.setState({buttonDisable:checkButtonstatus,buttonDisableInteg:buttonDisableInteg,company_name_req:incorrectUrl,disableVerifyButton:disableVerifyButton,apiVerified:apiVerified,verifyingApi:verifyingApi});
      if(this.props.signUp.signupUser && this.props.signUp.signupUser.company.step_completed === 4){
      this.setState({disableVerifyButton: true, apiVerified: true});
    }
  }
  // submit integration api process
  submitsimproApiInteg(e){
      e.preventDefault();
      let company_name=this.state.company_name
      let companiescheck=this.props.signUp && this.props.signUp.simproCompanies?this.props.signUp.simproCompanies:'';
      let companiesList=this.props.signUp.companiesApi ? this.props.signUp.companiesApi: '';
      var companyid= document.simproApiInteg.companyid.value
      var selectedCompany= this.state.value;
      var validation='true';
      if(companiescheck===''){
        validation='false';
      }
      if(selectedCompany===0 && companiesList){
          this.setState({selectCompanyReq: 'Please select a company.'});
          validation='false';
      }else{
        this.setState({selectCompanyReq: ''});
      }
      if(validation==='true'){
         this.props.addSimproApi(companyid,selectedCompany);
      }
  }    
  authorizeApi(){
    this.setState({buttonDisable:true});
    let company_name= this.state.company_name;
    let simpro_domain= this.state.simpro_domain_value;
    let simprouser=this.state.simproUsername;
    let simpropass=this.state.simproPassword;
    company_name=_.trim(company_name);
    if(simprouser===''){
      this.setState({simpro_name_req: "Please enter your simpro's user name.",buttonDisable: false});
      return false;
    }else{
      this.setState({simpro_name_req: ''});
    }
    if(simpropass===''){
      this.setState({simpro_pass_req: "Please enter your simpro's Password.",buttonDisable: false});
      return false;
    }else{
      this.setState({simpro_pass_req: ''});
    }
    if(company_name===''){
      this.setState({company_name_req: 'Please enter your company name.',buttonDisable: false});
      return false;
    }else{
      this.setState({company_name_req: ''});
    }
    let url= 'https://'+company_name+'.'+simpro_domain;
    var companyId=this.props.signUp.signupUser ? this.props.signUp.signupUser.company._id : '';
    if(!companyId){
      companyId= window.localStorage.getItem('temp_company_id');
    }
    if(companyId){
      this.props.authorizeApi(companyId,url,simprouser,simpropass);
    }
  }
  changeCompanyName(e){
    let compName= e.target.value;
    this.setState({company_name: compName});
  }
  simPROpassword(e){
    let simpropass= e.target.value;
    this.setState({simproPassword: simpropass});
  }
  simPROUser(e){
    let simprouser= e.target.value;
    this.setState({simproUsername: simprouser});
  }
  verifyApiUserPass(){
    let simprouser=this.state.simproUsername;
    let simpropass=this.state.simproPassword;
    let company_name= this.state.company_name;
    let simpro_domain= this.state.simpro_domain_value;
    let url= 'https://'+company_name+'.'+simpro_domain;
    // console.log('company id', this.props.signUp.signupUser.company._id);
    let companyId = this.props.signUp.signupUser.company._id;
    let validation=false;

    if(company_name===''){
      this.setState({company_name_req: 'Please enter your company name.',buttonDisable: false});
      return false;
    }else{
      this.setState({company_name_req: ''});
      validation=true;
    }
    if(simprouser===''){
      this.setState({simpro_name_req: "Please enter your simpro's user name.",buttonDisable: false});
      return false;
    }else{
      this.setState({simpro_name_req: ''});
      validation=true;
    }
    if(simpropass===''){
      this.setState({simpro_pass_req: "Please enter your simpro's Password.",buttonDisable: false});
      return false;
    }else{
      this.setState({simpro_pass_req: ''});
      validation=true
    }
    if(this.props.signUp.signupUser.company._id === null){
      this.setState({companyIderror: "company id not found"});
      alert('company id not found');
      return false;
    }
    if(validation){
      this.props.verifyUserPass(url,simprouser,simpropass, companyId);
    }
  }
  render() {
      var companyId=this.props.signUp.signupUser ? this.props.signUp.signupUser.company._id : '';
      if(!companyId){
           companyId= window.localStorage.getItem('temp_company_id');
        }
      return(<div>
                <div className="signup-page">
                        <div className="signup-left col-6">
                            <div className="show-information vissible-sm vissible-xs"  onClick={this.InformationToggle}>
                                <i className="zmdi zmdi-info"></i>
                            </div>
                            <div className="signup-form-section">
                              <div className="logo-dokkit">
                                  <figure>
                                      <Link to="#">
                                          <img src="/images/dokkit-logo.png" alt="logo" />
                                      </Link>
                                  </figure>
                              </div>
                                <form name="simproApiInteg" onSubmit = {this.submitsimproApiInteg}>
                                    <h3>Lets get you integrated</h3>
                                    <p>In order to get access to your job information in simPRO we need you to verify your simPRO credentials and give Dokkit authorisation to retrieve key information securely.</p>
                                     <Row className="margb25px">
                                         <Col xs={6}>
                                          <div className="vector-img">
                                            <figure>
                                              <img src="/images/vector-aart2.png" alt="vector-img" />
                                            </figure>
                                          </div>
                                        </Col>
                                        <Col xs={6}>
                                          <div className="vector-img">
                                            <figure>
                                              <img src="/images/vector-aart1.png" alt="vector-img" />
                                            </figure>
                                          </div>
                                        </Col>
                                     </Row>
                                     <Row>
                                      <form name="companyForm" onSubmit = {this.submitValidateCompanyData}>
                                          <Col md={12}>
                                            <h3>simPRO verification</h3>
                                            <Row>
                                              <Col md={12}>
                                                <h2>Please enter your simPRO company domain name</h2>
                                              </Col>
                                             </Row>
                                             <Row>
                                                  <Col md={6}>
                                                    <TextField
                                                        hintText="company name"
                                                        fullWidth={ false }
                                                        floatingLabelFixed={true}
                                                        name='company_name'
                                                        onChange={this.changeCompanyName}
                                                        errorText={this.state.company_name_req}
                                                    />
                                                  </Col>
                                                  <Col md={6}>
                                                      <SelectField
                                                        value={this.state.simpro_domain_value}
                                                        onChange={this.handleChange1}
                                                        name="simpro_domain"
                                                      >
                                                        <MenuItem value="simprosuite.com" primaryText=".simprosuite.com" />
                                                        <MenuItem value="simprocloud.com" primaryText=".simprocloud.com" />
                                                      </SelectField>
                                                  </Col>
                                             </Row>

                                            <Row>
                                                <Col md={12}>
                                                     <TextField
                                                        hintText="Enter your simPRO username"
                                                        fullWidth={ true }
                                                        floatingLabelFixed={true}
                                                        name='simpro_username'
                                                        errorText={this.state.simpro_name_req}
                                                        onChange={this.simPROUser}
                                                    />
                                                </Col>
                                            </Row>
                                          </Col>
                                          <Col md={12}>
                                            <Row>
                                                <Col md={12}>
                                                    <TextField
                                                        hintText="Enter your simPRO Password"
                                                        fullWidth={ true }
                                                        floatingLabelFixed={true}
                                                        name='simpro_password'
                                                        type="password"
                                                        errorText={this.state.simpro_pass_req}
                                                        onChange={this.simPROpassword}
                                                    />
                                                </Col>
                                            </Row>
                                            </Col>
                                        </form>
                                    </Row>
                                    <Row className="verify-simpro-username">
                                     <Col md={7} className="click-here-button">
                                      <h2>Please verify your simPRO login account</h2>
                                      </Col>
                                      <Col md={5} className="click-here-button">
                                        <RaisedButton 
                                          label={this.state.verifyingApi?<CircularProgress size={32} color="#fff"/>:"Verify"} 
                                          labelColor="#fff" 
                                          fullWidth={true} 
                                          disabled={this.state.disableVerifyButton || this.props.signUp.simproCompanies?true:false}
                                          onClick={this.verifyApiUserPass} 
                                          />
                                      </Col>
                                    </Row>
                                     <div className="please-click-heare">
                                      <Row>
                                       <Col md={7}>
                                        <h2>Please authorise your account</h2>
                                        </Col>
                                        <Col md={5} className="click-here-button">
                                          <RaisedButton 
                                            label={this.state.buttonDisable?<CircularProgress size={32} color="#fff"/>:"Authorise"} 
                                            labelColor="#fff" 
                                            fullWidth={true} 
                                            
                                            onClick={this.authorizeApi} 
                                            disabled={this.state.buttonDisable || this.props.signUp.simproCompanies || !this.state.apiVerified?true:false}
                                            />
                                        </Col>
                                      </Row>
                                      <Row>
                                        <Col md={12}>
                                          <h2 style={{'color':'#009900'}}>{this.props.signUp && this.props.signUp.simproCompanies?'Your account is authorised successfully.Please continue to login.': ''}</h2>
                                        </Col>
                                      </Row>
                                    </div>
                                    <Row>
                                        <Col xs={12}>
                                          <input type="hidden" value={companyId} name="companyid" />
                                          <RaisedButton type='Submit' disabled={(!this.state.buttonDisableInteg) && (this.props.signUp && this.props.signUp.simproCompanies)?false:true} label={this.state.buttonDisableInteg?<CircularProgress size={32} color="#fff"/>:"Get Started"} onClick = {this.submitsimproApiInteg} labelColor="#fff" fullWidth={true} />
                                        </Col>
                                    </Row>  
                                </form>
                            </div>

                            <div className="tab-navigation">
                                <ul>
                                    <li>
                                        <Link to="#">
                                            <span>1</span> Company Setup
                                        </Link>
                                    </li>
                                     <li>
                                        <Link to="#">
                                            <span>2</span> O&M Setup
                                        </Link>
                                    </li>
                                     <li className="active">
                                        <Link to="intergration-information">
                                            <span>3</span> Integration information
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={`signup-right col-6 display-flex ${this.state.information}`}>
                            <div className="right-content margin-auto">
                                <h3>Final step to go!</h3>
                                <figure>
                                    <img src="/images/intergration.png" alt="vector" />
                                </figure>
                                <div className="featured-list">
                                    <h2>Need help?</h2>
                                    <h4>Contact support at:</h4>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>
                                            <label>Email:</label>
                                            <u>info@dokkit.co.uk</u>
                                          </td>
                                          <td>
                                            <label>Phone:</label>
                                              01273 025218
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>
                                            <label>Find us on:</label>
                                            <ul>
                                              <li>
                                                <a href="https://www.facebook.com/Dokkit-212170182762203/" target="_blank">
                                                  <i className="zmdi zmdi-facebook-box"></i>
                                                </a>
                                              </li>
                                                                                         <li>
                                              <a href="https://twitter.com/dokkit_uk" target="_blank">
                                                  <i className="zmdi zmdi-twitter-box"></i>
                                                </a>
                                              </li>
                                                                                         <li>
                                              <a href="https://www.linkedin.com/company/dokkit-uk/" target="_blank">
                                                  <i className="zmdi zmdi-linkedin-box"></i>
                                                </a>
                                              </li>
                                            </ul>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                </div>       
             </div>    
      )
    }
}

const mapStateToProps= (state,props)=> {
  // console.log('signup', state.signup);
    return {
      signUp : state.signup
    };
}
export default connect(mapStateToProps,actions)(IntergrationInformation);



// WEBPACK FOOTER //
// ./src/Components/Modules/LoginSignup/IntergrationInformation.js